import { Link, useNavigate } from 'react-router-dom';
import { CompanySearchParams } from 'src/types';
import { Company, CompanyResults } from '../../types/ICompany';
import { DEFAULT_EMPTY_VALUE, PROVIDER_SOURCES } from 'src/constants/companyReport';
import { useContext } from 'react';
import { AppContext } from 'src/utils';

interface Props {
  companySearchResults: CompanyResults;
  companySearchParams: CompanySearchParams;
}

function CompanySearchList(props: Props) {
  const { currentUser } = useContext(AppContext);
  const navigate = useNavigate();
  const handleOnClick = (
    companyCode: string,
    countryISO: string,
    screening: string,
    displayRegNo: string,
    regAuth?: string,
    stateCode?: string,
  ) => {
    // Overwrite the screening based on user flags if a flag is present
    // Otherwise use what was about to be used
    const screeningValue = currentUser?.screening_disabled ? 'off' : screening;

    navigate(
      `/company-report/detail?companyCode=${companyCode}&countryISO=${countryISO}&displayRegNo=${displayRegNo}&screening=${screeningValue}` +
        (regAuth ? `&regAuth=${regAuth}` : '') +
        (stateCode ? `&stateCode=${stateCode}` : ''),
    );
  }

  return (
    <div className="row">
      <div className="col-lg-12">
        <div className="card w-100 companies-list">
          <table>
            <thead>
              <tr className="border-bottom">
                <th className="color-monoNormal">Company Name</th>
                <th className="color-monoNormal">Registration No.</th>
                <th className="color-monoNormal">Status</th>
                {props?.companySearchResults?.source === PROVIDER_SOURCES.DNB ? (
                  <th className="color-monoNormal">Location</th>
                ) : null}
                <th className="color-monoNormal">Address</th>
                <th className="color-monoNormal"></th>
              </tr>
            </thead>
            <tbody>
              {props.companySearchResults.companies.map((company: Company) => (
                <tr
                  onClick={() =>
                    handleOnClick(
                      company.companyCode,
                      props.companySearchParams.countryISO,
                      props.companySearchParams.screening,
                      company?.registrationNumber,
                      company.registrationAuthorityCode,
                      props.companySearchParams.stateCode,
                    )
                  }
                  key={company.registrationNumber}
                  className="hvg-bg"
                >
                  <td>{company?.companyName ?? DEFAULT_EMPTY_VALUE}</td>

                  <td title={company?.companyCode}>
                    {company?.registrationNumber ?? DEFAULT_EMPTY_VALUE}
                  </td>
                  <td>{company?.companyStatus ?? DEFAULT_EMPTY_VALUE}</td>
                  {props?.companySearchResults?.source === PROVIDER_SOURCES.DNB ? (
                    <td>
                      {company?.location?.length
                        ? company?.location[0]?.description
                        : DEFAULT_EMPTY_VALUE}
                    </td>
                  ) : null}
                  <td>
                    {company?.addresses?.length
                      ? company?.addresses[0]?.addressInOneLine
                      : DEFAULT_EMPTY_VALUE}
                  </td>
                  <td>
                    <Link
                      key={company.companyCode!}
                      to={`/company-report/detail?companyCode=${company.companyCode}&countryISO=${props.companySearchParams.countryISO}&screening=${props.companySearchParams.screening}&regAuth=${company.registrationAuthorityCode}&stateCode=${props.companySearchParams.stateCode}`}
                    >
                      <img
                        src={require('src/assets/images/icons/chevron-right-black.svg').default}
                        alt=""
                      />
                    </Link>
                  </td>
                </tr>
              ))}
            </tbody>
          </table>
        </div>
      </div>
    </div>
  );
}

export default CompanySearchList;
